import React from 'react'
import PropTypes from 'prop-types'
import { connectNumericMenu } from 'react-instantsearch-dom'
import MenuItem from '@material-ui/core/MenuItem'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { PillSelect } from './Refiners.styles'

const CustomNumericMenu = (props) => {
  const {
    currentRefinement,
    items,
    refine,
  } = props

  const defineLabel = (val) => {
    const filteredItem = items.find(item => item.value === val)
    return filteredItem.label === 'Show All' ? 'Price' : filteredItem.label
  }

  return (
    <PillSelect
      variant="outlined"
      value={currentRefinement}
      onChange={event => refine(event.target.value)}
      displayEmpty
      IconComponent={KeyboardArrowDownIcon}
      renderValue={value => defineLabel(value)}
    >
      {items.map(item => (
        <MenuItem
          key={item.value}
          value={item.isRefined ? currentRefinement : item.value}
          disabled={!item.noRefinement}
        >
          {item?.label}
        </MenuItem>
      ))}
    </PillSelect>
  )
}

CustomNumericMenu.propTypes = {
  currentRefinement: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    isRefined: PropTypes.bool,
    value: PropTypes.string,
    noRefinement: PropTypes.bool,
  })),
  refine: PropTypes.func,
}

export default connectNumericMenu(CustomNumericMenu)
